<p>
  След всяка успешно приключена сделка, и <strong>купувачът</strong>, и <strong>продавачът</strong> имат възможност да
  оставят отзив един за друг. Отзивите са важна част от изграждането на доверие в платформата и служат като основа за
  репутацията на всеки потребител.
</p>
<p>
  Целта на тази система е да осигури прозрачност и реална представа за поведението, комуникацията и коректността на
  участниците в търговията.
</p>
<h6 class="mt-3">
  Какви оценки могат да бъдат дадени?
</h6>
<p class="mb-1">
  Всеки отзив включва оценка в процентна стойност, която отразява цялостното впечатление от сделката:
</p>
<ul>
  <li><strong>0%</strong> – Много лошо преживяване</li>
  <li><strong>25%</strong> – Значителни проблеми по сделката</li>
  <li><strong>50%</strong> – Средно ниво, смесени впечатления</li>
  <li><strong>75%</strong> – Добро преживяване с леки забележки</li>
  <li><strong>100%</strong> – Отлично преживяване, напълно доволен</li>
</ul>
<h6 class="mt-3">
  Как се оставя отзив?
</h6>
<p class="mb-1">
  Навигирайте до страницата на артикула, по който е сключена сделката, и изберете бутона
  <strong>„Оценете продавача“</strong> или <strong>„Оценете купувача“</strong>. Ще имате възможност:
</p>
<ul>
  <li>да изберете една от процентните оценки;</li>
  <li>да използвате предварително дефиниран текст;</li>
  <li>или да въведете собствен коментар, описващ опита ви.</li>
</ul>
<h6 class="mt-3">
  Редакция и срокове
</h6>
<p>
  Отзивът може да бъде добавен или редактиран в срок до <strong>30 календарни дни</strong> след приключване на сделката.
  След този период отзивите се заключват и не подлежат на промяна.
</p>
<div class="m-0 alert alert-primary"><strong>Съвет:</strong> Давайте отзиви, които отразяват реалното ви преживяване –
  обективната и коректна обратна връзка е в основата на стабилна и честна общност.
</div>
